import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { UserContextService } from 'app/core/services/user-context.service';
import { updateUserDetails } from 'app/core/services/constants/urls';
import { EmployeeProfileService } from 'app/core/services/employee-profile.service';
import { map, switchMap, Observable, take } from 'rxjs';
import { UserManagementUpdateResponse } from 'app/features/user-management/models/user-management-updateResponse.model';

@Injectable({ providedIn: 'root' })
export class UserManagementService {
  mfaPhone$: Observable<string>;
  accountName$ = this.userContextService.userContext$.pipe(
    map(userContext => userContext.userName)
  );
  accountEmail$ = this.employeeProfileService.userMail$.pipe(map(personal => personal.email));

  constructor(
    private userContextService: UserContextService,
    private employeeProfileService: EmployeeProfileService,
    private http: HttpClient
  ) {}

  updateUserDetails(
    currentUserName: string,
    newUserName: string,
    newEmail: string
  ): Observable<UserManagementUpdateResponse> {
    return this.employeeProfileService.apiCreds$.pipe(
      take(1),
      map(personal => personal),
      switchMap(identity =>
        this.http.put<{ Success: boolean; ErrorMessage: string }>(updateUserDetails, {
          employeeId: identity.id,
          newUserName,
          currentUserName,
          newEmail,
          BCL: identity.bcl,
        })
      ),
      map(({ Success, ErrorMessage }) => ({
        Success,
        ErrorMessage,
      }))
    );
  }
}
